import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.User.ResetPassword.IRequest;
type Response = Api.Core.User.ResetPassword.IResponse;
type Headers = Api.Core.User.ResetPassword.IHeaders;
const url = '/api/Management/User/ResetPassword/:id';
export default async function userResetPasswordApi(id: number, body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
